class ImageMegaMenu {
  constructor() {
    this.drawer = document.querySelector('header-drawer');
    this.bindDesktopMenus();
    this.bindDrawer();
  }

  bindDesktopMenus() {
    document.querySelectorAll('.header__inline-menu > .list-menu > li > a.header__menu-item').forEach((link) => {
      link.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') this.closeAllDesktopMenus();
      });
    });

    document.querySelectorAll('header-menu .image-mega-menu').forEach((menu) => {
      const summary = menu.querySelector(':scope > summary');
      if (!summary) return;

      menu.addEventListener('toggle', () => this.syncDesktopScrollLock());

      menu.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse') return;
        this.openDesktopMenu(menu);
      });

      menu.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'mouse') return;
        window.setTimeout(() => {
          if (!menu.matches(':hover') && !menu.contains(document.activeElement)) {
            this.closeDesktopMenu(menu);
          }
        }, 100);
      });

      summary.addEventListener('click', (event) => {
        // A mouse click after hover should retain the open menu. Keyboard users
        // retain the native details toggle behavior.
        if (event.detail > 0 && menu.open) {
          event.preventDefault();
          summary.setAttribute('aria-expanded', 'true');
        }
      });

      menu.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !menu.open) return;
        event.preventDefault();
        this.closeDesktopMenu(menu);
        summary?.focus();
      });
    });
  }

  openDesktopMenu(menu) {
    this.closeAllDesktopMenus(menu);
    menu.setAttribute('open', '');
    menu.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'true');
    this.syncDesktopScrollLock();
  }

  closeAllDesktopMenus(exceptMenu = null) {
    document.querySelectorAll('header-menu .image-mega-menu[open]').forEach((openMenu) => {
      if (openMenu !== exceptMenu) this.closeDesktopMenu(openMenu);
    });
  }

  closeDesktopMenu(menu) {
    menu.removeAttribute('open');
    menu.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
    this.syncDesktopScrollLock();
  }

  syncDesktopScrollLock() {
    const hasOpenDesktopMenu = document.querySelector('header-menu .image-mega-menu[open]') !== null;
    document.body.classList.toggle('overflow-hidden-desktop', hasOpenDesktopMenu);
  }

  bindDrawer() {
    if (!this.drawer) return;

    this.drawer.querySelectorAll('[data-mega-drilldown-open]').forEach((button) => {
      button.addEventListener('click', () => this.openDrilldown(button));
    });

    this.drawer.querySelectorAll('[data-mega-drilldown-back]').forEach((button) => {
      button.addEventListener('click', () => this.closeDrilldown(button.closest('[data-mega-drilldown]')));
    });

    this.drawer.addEventListener(
      'keydown',
      (event) => {
        if (event.key !== 'Escape') return;
        const activePanel = this.drawer.querySelector('[data-mega-drilldown].is-active');
        if (!activePanel) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.closeDrilldown(activePanel);
      },
      true
    );

    this.drawer.querySelectorAll('details').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) this.resetDrilldowns(details);
      });
    });

    const mainDetails = this.drawer.querySelector(':scope > details');
    mainDetails?.addEventListener('toggle', () => {
      if (!mainDetails.open) {
        this.resetDrilldowns(mainDetails);
        const navigation = this.drawer.querySelector('.menu-drawer__navigation-container');
        if (navigation) navigation.scrollTop = 0;
      }
    });
  }

  openDrilldown(button) {
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;

    const scroller = button.closest('.menu-drawer__inner-submenu');
    panel.dataset.previousScroll = String(scroller?.scrollTop || 0);
    this.setBackgroundTabOrder(panel, false);
    button.setAttribute('aria-expanded', 'true');
    panel.setAttribute('aria-hidden', 'false');
    panel.classList.add('is-active');
    panel.scrollTop = 0;
    requestAnimationFrame(() => panel.querySelector('[data-mega-drilldown-back]')?.focus());
  }

  closeDrilldown(panel, restoreFocus = true) {
    if (!panel) return;

    const trigger = this.drawer.querySelector(`[aria-controls="${CSS.escape(panel.id)}"]`);
    const scroller = panel.closest('.menu-drawer__inner-submenu');
    panel.classList.remove('is-active');
    panel.setAttribute('aria-hidden', 'true');
    trigger?.setAttribute('aria-expanded', 'false');
    this.setBackgroundTabOrder(panel, true);

    if (restoreFocus) trigger?.focus();
    if (scroller) scroller.scrollTop = Number(panel.dataset.previousScroll || 0);
  }

  setBackgroundTabOrder(panel, restore) {
    const container = panel.closest('.menu-drawer__inner-submenu');
    if (!container) return;

    container.querySelectorAll('a, button, summary, [tabindex]').forEach((element) => {
      if (panel.contains(element)) return;
      if (restore) {
        if (element.dataset.megaPreviousTabindex !== undefined) {
          const previous = element.dataset.megaPreviousTabindex;
          previous === '' ? element.removeAttribute('tabindex') : element.setAttribute('tabindex', previous);
          delete element.dataset.megaPreviousTabindex;
        }
      } else if (element.dataset.megaPreviousTabindex === undefined) {
        element.dataset.megaPreviousTabindex = element.getAttribute('tabindex') || '';
        element.setAttribute('tabindex', '-1');
      }
    });
  }

  resetDrilldowns(scope) {
    scope.querySelectorAll('[data-mega-drilldown].is-active').forEach((panel) => {
      this.closeDrilldown(panel, false);
    });
  }
}

new ImageMegaMenu();
